import styled from "styled-components";
export const TermCheckContainer = styled.div.attrs({})`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  background-color: ${p => p.white ? p.theme.palette.colors.surfaceElevated : p.theme.palette.colors.inputSurface};
  padding: 18px 16px;
  border-radius: 16px;
  border: 1px solid ${p => p.theme.palette.colors.inputBorder};
  box-shadow: inset 0 1px 0 ${p => p.theme.palette.colors.borderSoft};
  transition: border-color 0.22s ease, background-color 0.22s ease, box-shadow 0.22s ease;

  &:hover {
    border-color: ${p => p.theme.palette.colors.borderStrong};
  }
`;


export const Text = styled.div.attrs({})`
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 1.55;
  color: ${p => p.small ? p.theme.palette.colors.subdued : p.theme.palette.colors.text};

  ${
    p => p.small ? `
      font-size: 12px;
    ` : ``
  }

  ${
    p => p.italic ? `
      font-style: italic;
    ` : ``
  }
`
export const StyledLink = styled.span.attrs({})`
  color: ${p => p.theme.palette.blue.main};
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  cursor: pointer;
`;

export const CheckContent = styled.span.attrs({})`
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 1;
  min-width: 0;
`;
